// extracted by mini-css-extract-plugin
export var avatarContainer = "_3o-0";
export var gray = "_3o-f";
export var green = "_3o-c";
export var icon = "_3o-9";
export var image = "_3o-1";
export var lg = "_3o-6";
export var md = "_3o-5";
export var presenceDot = "_3o-b";
export var red = "_3o-d";
export var sm = "_3o-4";
export var status = "_3o-a";
export var xl = "_3o-7";
export var xs = "_3o-3";
export var xxl = "_3o-8";
export var xxs = "_3o-2";
export var yellow = "_3o-e";